import { Col } from 'react-bootstrap'

const DigitalLibrary = () => (
    [
        {
            ImgUrl:"../images/home/img-ebook-what-your-doctor-wasnt-taught01.png",
            ImgAlt:"What your Doctor wasn't taught",
        },
        {
            ImgUrl:"../images/home/img-ebook-how-to-choose-a-high-quality-supplemet01.png",
            ImgAlt:"High Quality Food Supplement",
        },
        {
            ImgUrl:"../images/home/img-ebook-importance-of-iodine-in-pregnancy01.png",
            ImgAlt:"Importance of Iodine in Pregnancy",
        },
        {
            ImgUrl:"../images/home/img-ebook-6-ways-to-cleanse-your-body01.png",
            ImgAlt:"6 Ways to Cleanse your Body",
        }
    ].map((data, idx) => (
        <Col md={3} xs={6} key={idx} className="mb-4 text-center">
            <img src={data.ImgUrl} className="img-fluid m-2" alt={data.ImgAlt}/>
        </Col> 
    ))
);
export default DigitalLibrary; 